import Lottie, { type LottieProps } from 'react-lottie-player';
import animationData from './playfulCat.json';
import { CSSProperties } from 'react';

interface IPlayfulCatLottieProps extends Omit<LottieProps, 'animationData'> {
  height?: CSSProperties['height'];
  width?: CSSProperties['width'];
}

const PlayfulCatLottie = ({ height = 400, width = 400, ...props }: IPlayfulCatLottieProps) => {
  return (
    <Lottie
      {...props}
      animationData={animationData}
      loop
      play
      style={{
        height: height,
        width: width,
        ...props.style,
      }}
    />
  );
};

export default PlayfulCatLottie;
